import { DoRequest, HTTP_METHOD, ResponseType } from '@ps20-frontend/shop-integration-redux';
import { AxiosRequestConfig } from 'axios';
import { Feature } from '@ps20/bff-models';
import { isUwAzam } from '@ps20-frontend/utils';
import { IAppState } from '../../localStore';
import { isApigeeActiveAndNotPermasession, isSdwSession } from '../../selectors/transientState.selector';
import { isProdUrl } from '../../../portal';

export function getAxiosPostOptions(
  state: IAppState,
  requestPayload: DoRequest
): AxiosRequestConfig {
  return createAxiosRequestConfig(HTTP_METHOD.POST, state, requestPayload);
}

function getHeaders(
  state: IAppState,
  method: HTTP_METHOD,
  url: string
): Record<string, string | boolean | number | undefined> {
  const headers: Record<string, string | boolean | number | undefined> = {
    'X-Correlation-ID': state.saveProtocol.correlationId
  };
  if (
    isUwAzam(
      state.transientState.datenhaltung.kdv.perId,
      state.transientState.datenhaltung.sdw?.role,
    )
  ) {
    headers['Uw-Azam'] = true;
  }
  if (state.transientState.datenhaltung.kdv.sessionId) {
    headers['X-Amis-Auth'] = state.transientState.datenhaltung.kdv.sessionId;
  }
  const shouldAddAuthHeader =
    method === HTTP_METHOD.POST ||
    url?.includes('pollingId') ||
    url?.includes('sds') ||
    url?.includes('authenticate');
  if (isSdwSession(state) && !isApigeeActiveAndNotPermasession(state)) {
    headers['Sdw-Session'] = true;
    if (shouldAddAuthHeader) {
      headers['Authorization'] = 'Bearer ' + state.transientState.datenhaltung.sdw.accessToken;
    }
  } else if (isApigeeActiveAndNotPermasession(state)) {
    headers['Authorization'] = 'Bearer ' + state.transientState.datenhaltung.sdw.accessToken;
    headers['Apigee-Active'] = true;
    if (isSdwSession(state)) {
      headers['Sdw-Session'] = true;
      headers['content-type'] = 'application/json ;charset=UTF-8';
    }
  }
  if (
    state.transientState.featureToggles &&
    state.transientState.featureToggles[Feature.TEST_DATA] &&
    state.transientState?.testDaten
  ) {
    headers['TestDaten'] = btoa(unescape(encodeURIComponent(state.transientState.testDaten)));
  }

  if (state.transientState.datenhaltung.azamVorgangsId) {
    headers['Angebot_Id'] = state.transientState.datenhaltung.azamVorgangsId;
  }
  headers['Perma'] = state.transientState.datenhaltung.permasession;
  if (!isProdUrl()) {
    headers['Vt-Role'] = state.transientState.role;
  }
  return headers;
}

function getResponseType(responseTypeFromConfig: ResponseType): ResponseType {
  if (responseTypeFromConfig) {
    return responseTypeFromConfig;
  }
  return ResponseType.APPLICATION_JSON;
}

export function getAxiosGetOptions(
  state: IAppState,
  requestPayload: DoRequest
): AxiosRequestConfig {
  return createAxiosRequestConfig(HTTP_METHOD.GET, state, requestPayload);
}

function createAxiosRequestConfig(
  method: HTTP_METHOD,
  state: IAppState,
  doRequestPayload: DoRequest
): AxiosRequestConfig {
  const responseType = doRequestPayload.responseType;
  const transformResponse = doRequestPayload.transformResponse;
  const url = doRequestPayload.url;

  const options: AxiosRequestConfig = {
    method,
    headers: getHeaders(state, method, url),
    responseType: getResponseType(responseType)
  };

  if (transformResponse) {
    options.transformResponse = transformResponse;
  }

  return options;
}
